<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src='../../assets/snakes.gif' />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Edit the details</h4>
                       <form class="form-sample" @submit="onSubmit">
              <p class="card-description">
                <strong>Basic info</strong>
              </p>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Common Name" description="Common Name" label-for="input14">
                    <b-form-input type="text" v-model="name"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group description="Scientic Name" horizontal label="Scientic Name">
                    <b-form-input type="text" v-model="scientificName"></b-form-input>
                  </b-form-group>
                </div>
              </div>
                       <div class="row">
                              <div class="col-md-6">
                  <b-form-group description="Other Names" horizontal label="Other Names">
                    <b-form-input type="text" v-model="othernames"></b-form-input>
                  </b-form-group>
                </div>
                    <div class="col-md-6">
                       <b-form-group horizontal label="State">
                  <v-select multiple v-model="states" :options="option"></v-select>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Regional Name">
                    <b-form-input type="text" v-model="rname"></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
                <hr>
              <p class="card-description">
                <strong>Other Info</strong>
              </p>
               <div class="row">
                <div class="col-md-12">
                  <b-form-group horizontal label="Distribution">
                    <vue-editor v-model="distribution" required=""></vue-editor>
                  </b-form-group>
                </div>
                
              </div>
              <div class="row">
                <div class="col-md-6">
                   <b-form-group horizontal label="Venom Type">
                    <b-form-select v-model="venomType" class="mb-3">
      <option value="Highly Venomous">Highly Venomous</option>
      <option value="Mildly Venomous">Mildly Venomous</option>
      <option value="Non Venomous">Non Venomous</option>
    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Family" >
                      <b-form-select v-model="family" class="mb-3">
<option>Acrochordidae</option>
<option>Colubridae</option>
<option>Elapidae</option>
<option>Erycidae</option>
<option>Gerrhopilidae</option>
<option>Homalopsidae</option> 
<option>Natricidae</option>
<option>Pareidae</option>
<option>Pythonidae</option>
<option>Sibynophiidae</option> 
<option>Typhlopidae</option>
<option>Uropeltidae</option>
<option>Viperidae</option>
    </b-form-select>
                  </b-form-group>
                </div>
                 <div class="col-md-6">
                  <b-form-group horizontal label="Genus" >
                      <b-form-select v-model="genus" class="mb-3">
                    <option>Acrochordus</option> 
<option>Ahaetulla</option> 
<option>Amphiesma</option> 
<option>Atretium</option> 
<option>Boiga</option> 
<option>Bungarus</option> 
<option>Calliophis</option> 
<option>Cerberus</option>  
<option>Chrysopelea</option> 
<option>Coelognathus</option>  
<option>Daboia</option>  
<option>Dendrelaphis</option> 
<option>Dieurostus</option>  
<option>Dryocalamus</option> 
<option>Echis</option> 
<option>Eryx</option>  
<option>Fowlea</option> 
<option>Gerarda</option>  
<option>Gerrhopilus</option> 
<option>Grypotyphlops</option> 
<option>Hebius</option> 
<option>Hydrophis</option>  
<option>Hypnale</option>  
<option>Indotyphlops</option>  
<option>Liopeltis</option> 
<option>Lycodon</option> 
<option>Melanophidium</option> 
<option>Naja</option>  
<option>Oligodon</option>  
<option>Ophiophagus</option>  
<option>Platyceps</option>  
<option>Platyplectrurus</option>  
<option>Plectrurus</option> 
<option>Proahaetulla</option>  
<option>Ptyas</option>  
<option>Python</option>  
<option>Rhabdophis</option> 
<option>Rhabdops</option> 
<option>Rhinophis</option> 
<option>Sibynophis</option>  
<option>Teretrurus</option> 
<option>Trimeresurus (Craspedocephalus)</option>  
<option>Uropeltis</option> 
<option>Xylophis</option> 
    </b-form-select>
                  </b-form-group>
                </div>
                 <div class="col-md-6">
                  <b-form-group horizontal label="Occurence" >
                    <b-form-select v-model="occurence" class="mb-3">
      <option value="Common">Common</option>
      <option value="Uncommon">Uncommon</option>
      <option value="Rare">Rare</option>
    </b-form-select>
                  </b-form-group>
                </div>
              </div>
                         <div class="row">
                              <div class="col-md-6">
                  <b-form-group horizontal label="WLPA" >
                    <b-form-select v-model="wlpa" class="mb-3">
      <option value="Schedule  -I">Schedule  -I</option>
      <option value="Schedule  -II">Schedule  -II</option>
      <option value="Schedule  -III">Schedule  -III</option>
       <option value="Schedule  -IV">Schedule  -IV</option>
      <option value="Not Listed">Not Listed</option>
      <option value="Vulnerable (VU)">Vulnerable (VU)</option>
       <option value="Near Threatened (NT)">Near Threatened (NT)</option>
      <option value="Conservation Dependent (CD)">Conservation Dependent (CD)</option>
      <option value="Extinct (EX)">Extinct (EX)</option>
      <option value="Non Venomous">Extinct in the Wild (EW)</option>
    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="IUCN" >
                     <b-form-select v-model="iucn" class="mb-3">
      <option value="Not Evaluated (NE)">Not Evaluated (NE)</option>
      <option value="Data Deficient (DD)">Data Deficient (DD)</option>
      <option value="Least Concern (LC)">Least Concern (LC)</option>
       <option value="Critically Endangered (CR)">Critically Endangered (CR)</option>
      <option value="Endangered (EN)">Endangered (EN)</option>
      <option value="Vulnerable (VU)">Vulnerable (VU)</option>
       <option value="Near Threatened (NT)">Near Threatened (NT)</option>
      <option value="Conservation Dependent (CD)">Conservation Dependent (CD)</option>
      <option value="Extinct (EX)">Extinct (EX)</option>
      <option value="Non Venomous">Extinct in the Wild (EW)</option>
    </b-form-select>
                  </b-form-group>
                </div>
                </div>
                          <div class="row">
                              <div class="col-md-12">
                  <b-form-group horizontal label="Scalation" >
                    <vue-editor v-model="characteristics"></vue-editor>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group horizontal label="Description" >
                    <vue-editor v-model="description" required=""></vue-editor>
                  </b-form-group>
                </div>
                </div>
                 <div class="row">
                <div class="col-md-12">
                  <b-form-group horizontal label="Short Description" >
                    <vue-editor v-model="shortdes" required=""></vue-editor>
                  </b-form-group>
                </div>
                 <div class="col-md-6">
                       <b-form-group horizontal label="Assign to Expert">
                  <v-select multiple v-model="experts" :options="expert" required=""></v-select>
                   </b-form-group>
                  </div>
                </div>
                <b-button variant="primary" class="btn-fw" type="submit" style="float:right;">Update Data</b-button>
            </form>
          </div>
          <hr>
                  <div class="card-body">
                   <h4 class="card-title">Add New Images</h4>
                   <form class="form-sample" @submit="imagesubmit">
                  <div class="row">
                <div class="col-md-3">
                  <input type="file" accept="image/*" id="file" ref="file" required="" @change="onFileChanged">
             <div id="preview">
           <img v-if="url" :src="url" />
            </div>
             </div>
            <div class="col-md-3">
                  <b-form-group horizontal label="Caption" label-for="input15">
                    <b-form-input type="text"  v-model="caption"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group horizontal label="Author" label-for="input15">
                    <b-form-input type="text"  v-model="author"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-3"> <b-button variant="primary" class="btn-fw" type="submit">Add New Image</b-button></div>
              </div>
              </form>
                </div>
                <hr>
                  <div class="card-body">
                   <h4 class="card-title">View Images</h4>
                  <div class="row" v-for = "pic in photographs" v-bind:key="pic.url" style="margin-top:20px;">
                <div class="col-md-4">
                  <img v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/'+pic.url" height="auto" width="100%" />
             </div>
             <div class="col-md-4">
                <button class="btn btn-danger" @click="deleteImage(pic)">Delete</button>
             </div>
              </div>
                </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import vSelect from 'vue-select'
export default {
  name: 'news',
  props: ['id'],
  components: {
    VueEditor,
    vSelect
  },
  data () {
    return {
      file: null,
      ids: '',
      name: '',
      scientificName: '',
      distribution: '',
      othernames: '',
      characteristics: '',
      description: '',
      family: '',
      venomType: '',
      caption: '',
      author: '',
      occurence: '',
      reginonalNames: [{
        name: null,
        state: null
      }],
      snakeImages: [{
        snakes: null,
        credits: null
      }],
      selectedFile: null,
      url: '',
      loading: false,
      photographs: [],
      fid: '',
      option: ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar', 'Chandigarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Lakshadweep', 'Delhi', 'Puducherry'],
      selected: '',
      states: [],
      rname: '',
      wlpa: '',
      iucn: '',
      shortdes: '',
      items1: [],
      experts: [],
      expert: [],
      genus: ''
    }
  },
  mounted: function () {
    this.getExperts()
  },
  methods: {
    getExperts () {
      this.loading = true
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/user/experts',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.items1 = response.data.data
        var temp = []
        for (var i = 0; i < this.items1.length; i++) {
          var ty = this.items1[i].name
          temp.push(ty)
        }
        this.expert = temp
        this.loading = false
        this.getAll()
      }).catch(e => {
        this.errors.push(e)
      })
    },
    onFileChanged (event) {
      this.selectedFile = event.target.files[0]
      this.url = URL.createObjectURL(this.selectedFile)
    },
    addNewDetect: function () {
      this.reginonalNames.push({
        name: null,
        state: null
      })
    },
    resetForm () {
      this.author = ''
      this.caption = ''
      this.selectedFile = ''
      this.url = ''
      this.file = null
    },
    getAll () {
      this.loading = true
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/snake/' + this.id,
        method: 'POST',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.items = response.data.data
        var d = this.items
        this.fid = d._id
        this.name = d.name
        this.scientificName = d.scientificName
        this.distribution = d.distribution
        this.characteristics = d.characteristics
        this.description = d.description
        this.venomType = d.venomType
        this.family = d.family
        this.occurence = d.occurence
        this.states = d.states
        this.wlpa = d.wlpa
        this.iucn = d.iucn
        this.shortdes = d.shortdes
        this.rname = d.rname
        this.othernames = d.othernames
        this.genus = d.genus
        var temp = []
        if (d.experts.length > 0) {
          for (var p = 0; p < this.items1.length; p++) {
            for (var i = 0; i < d.experts.length; i++) {
              if (d.experts[i] === this.items1[p]._id) {
                var ty = this.items1[p].name
                temp.push(ty)
              }
            }
          }
        }
        this.experts = temp
        var tempr = []
        for (var j = 0; j < d.photographs.length; j++) {
          var tyz = {
            _id: d.photographs[j]._id,
            author: d.photographs[j].author,
            caption: d.photographs[j].caption,
            url: d.photographs[j].url
          }
          tempr.push(tyz)
        }
        this.photographs = tempr
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      var temp = []
      for (var i = 0; i < this.items1.length; i++) {
        for (var j = 0; j < this.experts.length; j++) {
          if (this.items1[i].name === this.experts[j]) {
            var ty = this.items1[i]._id
            temp.push(ty)
          }
        }
      }
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/snake/edit ',
        data: {
          id: this.id,
          name: this.name,
          scientificName: this.scientificName,
          states: this.states,
          rname: this.rname,
          distribution: this.distribution,
          characteristics: this.characteristics,
          description: this.description,
          venomType: this.venomType,
          family: this.family,
          occurence: this.occurence,
          wlpa: this.wlpa,
          iucn: this.iucn,
          shortdes: this.shortdes,
          othernames: this.othernames,
          experts: temp,
          genus: this.genus
        },
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      })
        .then(response => {
          alert('Successfully Updated Data')
          this.loading = false
          this.getExperts()
        })
        .catch(e => {
          this.loading = false
          alert('Failed')
        })
    },
    imagesubmit (evt) {
      evt.preventDefault()
      this.loading = true
      let formData = new FormData()
      formData.append('id', this.id)
      formData.append('photo', this.selectedFile)
      formData.append('caption', this.caption)
      formData.append('author', this.author)
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/snake/image/',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-auth-token': localStorage.getItem("token")
        }
      })
        .then(response => {
          alert('Image Added Successfully')
          this.resetForm()
          this.getAll()
          this.loading = false
        })
        .catch(e => {
          alert('Too Large image!! Failed')
          this.loading = false
        })
    },
    deleteImage: function (item) {
      var vm = this
      vm.item = item._id
      this.loading = true
      axios({
        method: 'POST',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
        url: 'https://sarpatnapi.leopardtechlabs.in/snake/remove/image/',
        data: {
          id: vm.fid,
          pid: vm.item
        }
      }).then(response => {
        alert('Successfully Deleted Snake Image')
        this.getAll()
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/editsnake.vue